import {ChangeDetectionStrategy, Component} from '@angular/core'

@Component({
  selector: 'bgo-navbar-left',
  templateUrl: './navbar-left.component.html',
  styles: [':host { display: block; }'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NavbarLeftComponent {}
